export default {
  chrome: 'Chrome',
  firefox: 'Firefox',
  electron: 'Electron',
  opera: 'Opera',
  edge: 'Edge',
  ie: 'IE',
  safari: 'Safari',
};
